import { InjectionToken } from '@angular/core';
import { type RedirectSourceEnum } from '@reconcept-platform/env';

export const BE_API_URL = new InjectionToken<string>('BE_API_URL');
export const AUTH_APP_ID = new InjectionToken<string>('AUTH_APP_ID');
export const AUTH_REDIRECT_URI = new InjectionToken<string>('AUTH_REDIRECT_URI');
export const AUTH_REDIRECT_SOURCE = new InjectionToken<RedirectSourceEnum>('AUTH_REDIRECT_SOURCE');
export const AUTH_SCOPE = new InjectionToken<string>('AUTH_SCOPE');
export const AUTH_API_URL = new InjectionToken<string>('AUTH_API_URL');
export const AUTH_APP_URL = new InjectionToken<string>('AUTH_APP_URL');
